import CurrentPage           from "../../../domain/fundamentals/pagination/CurrentPage";
import Pagination            from "../../../domain/fundamentals/pagination/Pagination";
import TotalPage             from "../../../domain/fundamentals/pagination/TotalPage";
import Plan                  from "../../../domain/plan/Plan";
import PlanId                from "../../../domain/plan/PlanId";
import Plans                 from "../../../domain/plan/Plans";
import PlanStatusType        from "../../../domain/plan/PlanStatusType";
import ReservationId         from "../../../domain/reservation/ReservationId";
import { ApiClient }         from "../../configure/ApiClientConfig";
import { toPlan }            from "../../translator/plan";
import { PlanResponseType }  from "./PlanResponseType";
import { PlansResponseType } from "./PlansResponseType";

export const apiGetPlans = async (pagination: Pagination): Promise<{ plans: Plans, pagination: Pagination }> => {
  const response = await ApiClient.get("/plans", {
    params: {
      page: pagination.current.value
    }
  });

  const data: PlansResponseType = response.data;
  const list: Plan[] = data.plans.map(plan => toPlan(plan));
  return {
    plans: new Plans(list),
    pagination: new Pagination(
      new CurrentPage(data.pagination.current),
      new TotalPage(data.pagination.total),
    ),
  };
}

export const apiGetPlanReservationId = async (reservationId: ReservationId): Promise<Plan> => {
  const response = await ApiClient.get("/reservation/plan", {
    params: {
      reservation_id: reservationId.value,
    }
  });

  const data: PlanResponseType = response.data;
  return toPlan(data);
}

export const apiGetPlansCount = async (): Promise<number> => await ApiClient.get("/plans/count");

export const apiPostPlan = async (plan: Plan): Promise<void> => {
  return await ApiClient.post("/plan", {
    id: plan.id.toNumber(),
    name: plan.name.toString(),
    description: plan.description.toString(),
    amount: plan.amount.toNumber(),
    tax_include_type: plan.taxIncludeType,
    time_type: plan.timeType,
    status_type: plan.statusType,
    day_limit: plan.dayLimit.toNumber(),
  });
}

export const apiPutPlan = async (plan: Plan): Promise<void> => await ApiClient.put("/plan", {
  id: plan.id.toNumber(),
  name: plan.name.toString(),
  description: plan.description.toString(),
  amount: plan.amount.toNumber(),
  tax_include_type: plan.taxIncludeType,
  time_type: plan.timeType,
  status_type: plan.statusType,
  day_limit: plan.dayLimit.toNumber(),
});

export const apiDeletePlan = async (planId: PlanId): Promise<void> => await ApiClient.delete("/plan", {
  params: {
    plan_id: planId.toString()
  }
});

export const apiPutPlanStatus = async (planId: PlanId, statusType: PlanStatusType): Promise<void> => await ApiClient.put("/plan/status", {
  id: planId.toNumber(),
  status_type: statusType
});